// i18n.js
// Centralise les traductions et expose des helpers

export const translations = {
  fr: {
    title: 'MP3 Tag Editor Pro',
    subtitle: 'Éditeur de tags MP3 en ligne',
    loadFiles: 'Charger des fichiers',
    downloadAll: 'Télécharger tous les MP3',
    files: 'Fichiers',
    search: 'Rechercher...',
    noFiles: 'Aucun fichier chargé',
    clickToStart: 'Cliquez sur "Charger des fichiers" pour commencer',
    tags: 'Tags',
    cover: 'Pochette',
    export: 'Export',
    save: 'Sauvegarder',
    saving: 'Sauvegarde...',
    downloadModified: 'Télécharger MP3 modifié',
    addCover: 'Ajouter une pochette',
    loadImage: 'Charger une image',
    remove: 'Supprimer',
    processing: 'Traitement en cours...',
    ready: 'Prêt',
    filesLoaded: 'fichier(s) chargé(s)',
    unsavedChanges: 'Vous avez des modifications non sauvegardées. Voulez-vous les sauvegarder avant de continuer ?',
    applyToAll: 'Appliquer cette pochette à tous les fichiers',
    selectFile: 'Sélectionnez un fichier',
    clickToAddCover: 'Cliquez pour ajouter une pochette',
    unknownArtist: 'Artiste inconnu',
    selectedFile: 'Fichier sélectionné:',
    howToUse: 'Comment utiliser',
    collectionStats: 'Statistiques de la collection',
    withArtist: 'Avec artiste',
    withAlbum: 'Avec album',
    albumLevel: 'Niveau album',
    trackLevel: 'Niveau piste',
    trackNeedsSelection: 'Sélectionnez une piste pour modifier ses champs spécifiques.',
    albumTitleLabel: "Titre de l'album",
    albumArtistLabel: "Artiste de l'album",
    trackTitleLabel: 'Titre de la piste',
    trackArtistLabel: 'Artiste de la piste',
    albumCommentLabel: 'Commentaire global',
    trackCommentLabel: 'Commentaire piste',
    albumCoverTitle: 'Pochette de l’album',
    trackCoverTitle: 'Pochette spécifique à la piste',
    coverAlbumHeader: 'Pochette actuelle',
    coverTrackHeader: 'Pochette actuelle',
    sharedCoverHint: 'Cliquez pour définir la pochette commune',
    trackCoverFallback: 'Cliquez pour ajouter une pochette',
    albumModeLabel: 'Mode album',
    albumModeEnable: 'Activer',
    albumModeDisable: 'Désactiver',
    albumModeHintOn: 'Les champs album sont appliqués à toutes les pistes.',
    albumModeHintOff: 'Chaque piste est gérée individuellement.',
    albumModeSelectPrompt: 'Plusieurs fichiers sont chargés ({count}). Entrez le numéro du fichier contenant les informations communes (laisser vide pour repartir de zéro) :',
    albumModeResetConfirm: 'Repartir de zéro pour les informations d’album ?',
    advancedModeLabel: 'Mode avancé',
    advancedModeEnable: 'Afficher tout',
    advancedModeDisable: 'Masquer le reste',
    advancedModeHintOn: 'Tous les champs (avancés) sont visibles.',
    advancedModeHintOff: 'Affiche seulement les champs essentiels.',
    coverApplyAlbum: 'Appliquer à tout l’album',
    coverApplyAll: 'Appliquer à toute la liste',
    confirmTitle: 'Confirmation',
    confirmYes: 'Oui',
    confirmNo: 'Non',
    confirmCoverAlbum: 'Voulez-vous appliquer cette pochette à toutes les pistes de l’album ?',
    confirmCoverAll: 'Voulez-vous appliquer cette pochette à tous les fichiers de la liste ?',
    confirmApplyAlbum: 'Appliquer à l’album',
    confirmApplyAll: 'Appliquer à tous',
    confirmAlbumEnable: 'Activer le mode album ? Les informations partagées seront appliquées à toutes les pistes.',
    confirmAlbumDisable: 'Désactiver le mode album ? Les pistes redeviendront indépendantes.',
    sources: 'Sources',
    sourceSelect: 'Source de métadonnées',
    sourceDiscogsTokenLabel: 'Jeton personnel Discogs',
    sourceDiscogsTokenPlaceholder: 'token123456...',
    sourceDiscogsTokenHelp: 'Utilisez un jeton personnel Discogs (Paramètres > Développeurs) ou une paire clé/secret.',
    sourceDiscogsKeyLabel: 'Clé API Discogs',
    sourceDiscogsKeyPlaceholder: 'maCle123',
    sourceDiscogsSecretLabel: 'Secret API Discogs',
    sourceDiscogsSecretPlaceholder: 'monSecret456',
    sourceDiscogsKeyHelp: 'Vous pouvez aussi utiliser une clé + un secret API (Paramètres > Applications) à la place du jeton.',
    sourceQueryLabel: 'Recherche globale',
    sourceQueryPlaceholder: 'Nom de l’album ou de la piste',
    sourceArtistLabel: 'Filtre artiste',
    sourceArtistPlaceholder: 'Nom de l’artiste',
    sourceAlbumLabel: 'Filtre album',
    sourceAlbumPlaceholder: 'Album ou sortie',
    sourceSearchButton: 'Rechercher des métadonnées',
    sourceSearching: 'Recherche...',
    sourceClear: 'Vider les résultats',
    sourceResultsCount: '{count} résultat(s)',
    sourceApplied: 'Métadonnées appliquées au fichier courant',
    sourceApplying: 'Application des métadonnées...',
    sourceNoResults: 'Aucune sortie correspondante trouvée.',
    sourceApply: 'Appliquer au fichier',
    sourceOpenLink: 'Ouvrir la page source',
    sourceUnknownTitle: 'Sortie sans titre',
    sourceScore: 'Score : {score}',
    sourceCountryLabel: 'Pays',
    sourceLabelLabel: 'Label',
    sourceCustomTitle: 'Sources personnalisées',
    sourceCustomDescription: 'Ajoutez des API JSON simples comme sources de métadonnées. Utilisez {query}, {artist}, {album} ou {track} dans l’URL.',
    sourceCustomName: 'Nom de la source',
    sourceCustomNamePlaceholder: 'Catalogue vinyle',
    sourceCustomUrl: 'Modèle d’URL',
    sourceCustomUrlPlaceholder: 'https://exemple.com/recherche?term={query}',
    sourceCustomResultPath: 'Chemin du tableau',
    sourceCustomResultPathPlaceholder: 'data.items',
    sourceCustomTagsJson: 'Correspondance de tags (JSON)',
    sourceCustomTagsJsonPlaceholder: '{"composer":"meta.composer"}',
    sourceCustomFieldMapLabel: 'Champ pour {field}',
    sourceCustomFieldMapPlaceholder: 'ex. metadata.titre',
    sourceCustomAdd: 'Ajouter la source',
    sourceCustomHint: 'La réponse doit être un JSON (objet ou tableau).',
    sourceCustomListTitle: 'Sources personnalisées enregistrées',
    sourceCustomEmpty: 'Aucune source personnalisée pour le moment.',
    sourceErrors: {
      emptyQuery: 'Saisissez au moins un critère (recherche, artiste ou album).',
      noFile: 'Sélectionnez un fichier avant d’appliquer des métadonnées.',
      missingFields: 'Nom et modèle d’URL obligatoires.',
      invalidTagsJson: 'JSON invalide pour les tags supplémentaires.',
      auth: 'Authentification requise ou identifiants invalides pour cette source.',
      rateLimit: 'Limite de requêtes atteinte. Réessayez plus tard.',
      generic: 'Impossible de récupérer les métadonnées pour cette source. Réessayez plus tard.'
    },
    fieldLabels: {
      title: 'Titre',
      artist: 'Artiste',
      album: 'Album',
      albumArtist: "Artiste de l'album",
      year: 'Année',
      track: 'Piste',
      totalTracks: 'Nombre de pistes',
      disc: 'Disque',
      totalDiscs: 'Nombre de disques',
      genre: 'Genre',
      comment: 'Commentaire',
      composer: 'Compositeur',
      bpm: 'BPM',
      key: 'Tonalité',
      language: 'Langue',
      copyright: 'Copyright',
      encoder: 'Encodeur',
      lyrics: 'Paroles'
    },
    header: {
      home: 'MP3 TAG EDITOR',
      about: 'À propos',
      history: 'Historique',
      contact: 'Contact',
      kracRadio: 'KracRadio',
      donation: 'Faire un don',
      store: 'Boutique'
    },
    footer: {
      description: "Éditeur de tags MP3 en ligne, gratuit et facile à utiliser. Modifiez vos métadonnées musicales directement dans votre navigateur.",
      usefulLinks: "Liens utiles",
      guide: "Guide d'utilisation",
      formats: "Formats supportés",
      faq: "FAQ",
      reportBug: "Signaler un bug",
      contact: "Contact",
      codeOnGithub: "Code source sur GitHub",
      madeWithLove: "Fait avec passion",
      localProcessing: "Traitement 100% local",
      noUpload: "Aucun fichier envoyé sur serveur",
      openSource: "Open source et gratuit",
      privacy: "Confidentialité",
      terms: "Conditions d'utilisation",
      rightsReserved: "Tous droits réservés.",
      version: "Version",
      information: "Information"
    },
    contactPage: {
      title: 'Contact',
      subtitle: "Écrivez-nous, on vous répond rapidement.",
      nameLabel: 'Nom',
      emailLabel: 'Courriel',
      messageLabel: 'Message',
      namePlaceholder: 'Votre nom',
      emailPlaceholder: 'vous@exemple.com',
      messagePlaceholder: 'Votre message...',
      send: 'Envoyer',
      sending: 'Envoi...',
      successTitle: 'Merci !',
      successBody: 'Votre message a été envoyé. Nous vous répondrons bientôt.',
      errorTitle: 'Oups…',
      errorBody: "Impossible d'envoyer le message. Réessayez plus tard."
    },
    historyPage: {
      title: 'Historique',
      subtitle: 'Notes de versions et changements récents.',
      sourceReleases: 'Source : GitHub Releases',
      sourceCommits: 'Source : Commits (branche)',
      publishedOn: 'Publié le',
      by: 'par',
      viewOnGitHub: 'Voir sur GitHub',
      noItems: 'Aucun élément à afficher.'
    },
    aboutPage: {
      title: 'À propos de KEMP3',
      intro: 'KEMP3 est un éditeur de tags MP3 rapide et respectueux de la vie privée, directement dans le navigateur. Pas d’installation, pas d’envoi de fichiers : vous éditez et téléchargez.',
      versionLabel: 'Version',
      releasedOn: 'Publié le',
      featuresTitle: 'Nouveautés de la 1.0',
      privacyTitle: 'Confidentialité par conception',
      privacyBody: 'Tout le traitement audio se fait localement dans votre navigateur. Aucun fichier audio ni métadonnée ne sont envoyés à un serveur.',
      kracTitle: 'Créée pour KracRadio',
      kracBody: "KEMP3 est développée par H1Site.com pour KracRadio, une webradio indépendante de Montréal qui met de l’avant la musique indie et underground via plusieurs canaux.",
      sourcesTitle: 'Sources',
      readMore: 'Afficher les détails',
      readLess: 'Masquer les détails',
      features: [
        "Édition complète des tags MP3 (titre, artiste, album, année, piste, genre, paroles, …)",
        "Ajout/suppression de pochette + application à tous les fichiers",
        "Téléchargement en lot avec tags intégrés",
        "Exports : CSV / HTML / JSON",
        "Recherche + statistiques de collection",
        "3 langues (FR / EN / ES)",
        "Aucun envoi : traitement 100% local",
        "Thème clair/sombre + header/footer responsive"
      ],
      nameTitle: 'Pourquoi “KEMP3” ?',
      nameBody1: 'Le nom rend hommage à Eric Kemp (“NamkraD”), qui a introduit en 1996 le premier format de tag ID3 (ID3v1) — une petite étiquette de 128 octets ajoutée à la fin des MP3.',
      nameBody2: 'Kemp était à la fois musicien et programmeur — l’esprit même que l’on célèbre ici : pratique, musical et orienté maker.',
      nameSources: [
        { label: 'id3.org — ID3v1', url: 'https://id3.org/ID3v1' },
        { label: 'id3.org — History', url: 'https://id3.org/History' },
        { label: 'id3.org — Introduction', url: 'https://id3.org/Introduction' }
      ],
      kracLinks: [
        { label: 'KracRadio (FR)', url: 'https://kracradio.com/' },
        { label: 'KracRadio (EN)', url: 'https://kracradio.com/en' }
      ]
    }
  },

  en: {
    title: 'MP3 Tag Editor Pro',
    subtitle: 'Online MP3 Tag Editor',
    loadFiles: 'Load Files',
    downloadAll: 'Download All MP3s',
    files: 'Files',
    search: 'Search...',
    noFiles: 'No files loaded',
    clickToStart: 'Click "Load Files" to start',
    tags: 'Tags',
    cover: 'Cover',
    export: 'Export',
    save: 'Save',
    saving: 'Saving...',
    downloadModified: 'Download Modified MP3',
    addCover: 'Add Cover',
    loadImage: 'Load Image',
    remove: 'Remove',
    processing: 'Processing...',
    ready: 'Ready',
    filesLoaded: 'file(s) loaded',
    unsavedChanges: 'You have unsaved changes. Do you want to save them before continuing?',
    applyToAll: 'Apply this cover to all files',
    selectFile: 'Select a file',
    clickToAddCover: 'Click to add a cover',
    unknownArtist: 'Unknown artist',
    selectedFile: 'Selected file:',
    howToUse: 'How to use',
    collectionStats: 'Collection Statistics',
    withArtist: 'With artist',
    withAlbum: 'With album',
    albumLevel: 'Album level',
    trackLevel: 'Track level',
    trackNeedsSelection: 'Select a track to edit its specific fields.',
    albumTitleLabel: 'Album title',
    albumArtistLabel: 'Album artist',
    trackTitleLabel: 'Track title',
    trackArtistLabel: 'Track artist',
    albumCommentLabel: 'Global comment',
    trackCommentLabel: 'Track comment',
    albumCoverTitle: 'Album cover',
    trackCoverTitle: 'Track-specific cover',
    coverAlbumHeader: 'Current cover',
    coverTrackHeader: 'Current cover',
    sharedCoverHint: 'Click to set the shared cover',
    trackCoverFallback: 'Click to add a cover',
    albumModeLabel: 'Album mode',
    albumModeEnable: 'Enable',
    albumModeDisable: 'Disable',
    albumModeHintOn: 'Album fields will be applied to every track.',
    albumModeHintOff: 'Each track keeps its own metadata.',
    albumModeSelectPrompt: 'Multiple files detected ({count}). Enter the number of the file that carries the shared album details (leave empty to start from scratch):',
    albumModeResetConfirm: 'Start a new album template from scratch?',
    advancedModeLabel: 'Advanced mode',
    advancedModeEnable: 'Show all',
    advancedModeDisable: 'Hide extras',
    advancedModeHintOn: 'All tag fields are visible.',
    advancedModeHintOff: 'Only the essential fields are shown.',
    coverApplyAlbum: 'Apply to album',
    coverApplyAll: 'Apply to all tracks',
    confirmTitle: 'Confirmation',
    confirmYes: 'Yes',
    confirmNo: 'No',
    confirmCoverAlbum: 'Apply this cover to every track in the album?',
    confirmCoverAll: 'Apply this cover to every file in the list?',
    confirmApplyAlbum: 'Apply to album',
    confirmApplyAll: 'Apply to all',
    confirmAlbumEnable: 'Enable album mode? Shared fields will be pushed to every track.',
    confirmAlbumDisable: 'Disable album mode? Tracks will go back to individual values.',
    sources: 'Sources',
    sourceSelect: 'Metadata source',
    sourceDiscogsTokenLabel: 'Discogs personal token',
    sourceDiscogsTokenPlaceholder: 'token123456...',
    sourceDiscogsTokenHelp: 'Use a Discogs personal token (Settings > Developers) or an API key/secret pair.',
    sourceDiscogsKeyLabel: 'Discogs API key',
    sourceDiscogsKeyPlaceholder: 'myKey123',
    sourceDiscogsSecretLabel: 'Discogs API secret',
    sourceDiscogsSecretPlaceholder: 'mySecret456',
    sourceDiscogsKeyHelp: 'You can also supply a key + secret (Settings > Applications) instead of the token.',
    sourceQueryLabel: 'Global query',
    sourceQueryPlaceholder: 'Album or song name',
    sourceArtistLabel: 'Artist filter',
    sourceArtistPlaceholder: 'Artist name',
    sourceAlbumLabel: 'Release filter',
    sourceAlbumPlaceholder: 'Album or release',
    sourceSearchButton: 'Search metadata',
    sourceSearching: 'Searching...',
    sourceClear: 'Clear results',
    sourceResultsCount: 'Results: {count}',
    sourceApplied: 'Metadata applied to current file',
    sourceApplying: 'Applying metadata...',
    sourceNoResults: 'No matching releases found.',
    sourceApply: 'Apply to file',
    sourceOpenLink: 'Open source page',
    sourceUnknownTitle: 'Untitled release',
    sourceScore: 'Score: {score}',
    sourceCountryLabel: 'Country',
    sourceLabelLabel: 'Label',
    sourceCustomTitle: 'Custom tag sources',
    sourceCustomDescription: 'Add simple JSON endpoints as metadata sources. Use {query}, {artist}, {album}, or {track} in the URL.',
    sourceCustomName: 'Source name',
    sourceCustomNamePlaceholder: 'My vinyl catalog',
    sourceCustomUrl: 'URL template',
    sourceCustomUrlPlaceholder: 'https://example.com/search?term={query}',
    sourceCustomResultPath: 'Result path',
    sourceCustomResultPathPlaceholder: 'data.items',
    sourceCustomTagsJson: 'Additional tag mapping (JSON)',
    sourceCustomTagsJsonPlaceholder: '{"composer":"meta.composer"}',
    sourceCustomFieldMapLabel: 'Field path for {field}',
    sourceCustomFieldMapPlaceholder: 'e.g. metadata.title',
    sourceCustomAdd: 'Add custom source',
    sourceCustomHint: 'Responses must be JSON arrays or objects.',
    sourceCustomListTitle: 'Saved custom sources',
    sourceCustomEmpty: 'No custom sources yet.',
    sourceErrors: {
      emptyQuery: 'Enter at least one search term (query, artist, or album).',
      noFile: 'Select a file before applying metadata.',
      missingFields: 'Name and URL template are required.',
      invalidTagsJson: 'Invalid JSON mapping for additional tags.',
      auth: 'Authentication required or invalid credentials for this source.',
      rateLimit: 'Rate limit reached. Please wait and try again.',
      generic: 'Unable to fetch metadata from the selected source. Please retry later.'
    },
    fieldLabels: {
      title: 'Title',
      artist: 'Artist',
      album: 'Album',
      albumArtist: 'Album Artist',
      year: 'Year',
      track: 'Track',
      totalTracks: 'Total Tracks',
      disc: 'Disc',
      totalDiscs: 'Total Discs',
      genre: 'Genre',
      comment: 'Comment',
      composer: 'Composer',
      bpm: 'BPM',
      key: 'Key',
      language: 'Language',
      copyright: 'Copyright',
      encoder: 'Encoder',
      lyrics: 'Lyrics'
    },
    header: {
      home: 'MP3 TAG EDITOR',
      about: 'About',
      history: 'History',
      contact: 'Contact',
      kracRadio: 'KracRadio',
      donation: 'Donate',
      store: 'Store'
    },
    footer: {
      description: "Free and easy-to-use online MP3 tag editor. Edit your music metadata directly in your browser.",
      usefulLinks: "Useful links",
      guide: "User guide",
      formats: "Supported formats",
      faq: "FAQ",
      reportBug: "Report a bug",
      contact: "Contact",
      codeOnGithub: "Source code on GitHub",
      madeWithLove: "Made with passion",
      localProcessing: "100% local processing",
      noUpload: "No files sent to server",
      openSource: "Open source and free",
      privacy: "Privacy",
      terms: "Terms of use",
      rightsReserved: "All rights reserved.",
      version: "Version",
      information: "Information"
    },
    contactPage: {
      title: 'Contact',
      subtitle: 'Send us a message — we usually reply quickly.',
      nameLabel: 'Name',
      emailLabel: 'Email',
      messageLabel: 'Message',
      namePlaceholder: 'Your name',
      emailPlaceholder: 'you@example.com',
      messagePlaceholder: 'Your message...',
      send: 'Send',
      sending: 'Sending...',
      successTitle: 'Thanks!',
      successBody: 'Your message has been sent. We will get back to you soon.',
      errorTitle: 'Oops…',
      errorBody: 'Unable to send the message. Please try again later.'
    },
    historyPage: {
      title: 'History',
      subtitle: 'Release notes and recent changes.',
      sourceReleases: 'Source: GitHub Releases',
      sourceCommits: 'Source: Commits (branch)',
      publishedOn: 'Published on',
      by: 'by',
      viewOnGitHub: 'View on GitHub',
      noItems: 'No items to display.'
    },
    aboutPage: {
      title: 'About KEMP3',
      intro: 'KEMP3 is a fast, privacy-first MP3 tag editor in your browser. No installs, no uploads — just edit and download.',
      versionLabel: 'Version',
      releasedOn: 'Released on',
      featuresTitle: 'What’s in 1.0',
      privacyTitle: 'Privacy by design',
      privacyBody: 'All audio processing happens locally in your browser. No audio files or metadata are sent to any server.',
      kracTitle: 'Built for KracRadio',
      kracBody: 'KEMP3 is developed by H1Site.com for KracRadio, an independent Montreal web radio showcasing indie and underground music through multiple channels.',
      sourcesTitle: 'Sources',
      readMore: 'Show details',
      readLess: 'Hide details',
      features: [
        "Full MP3 tag editing (title, artist, album, year, track, genre, lyrics, …)",
        "Cover art add/remove + apply to all files",
        "Batch download with embedded tags",
        "Exports: CSV / HTML / JSON",
        "Search + collection stats",
        "3 languages (FR / EN / ES)",
        "No uploads: 100% local processing",
        "Light/Dark theme + responsive header/footer"
      ],
      nameTitle: 'Why “KEMP3”?',
      nameBody1: 'The name honors Eric Kemp (“NamkraD”), who introduced the first ID3 tag format (ID3v1) in 1996 — a tiny 128-byte tag appended to MP3 files.',
      nameBody2: 'Kemp was both a musician and a programmer — exactly the spirit we celebrate here: practical, musical, and maker-minded.',
      nameSources: [
        { label: 'id3.org — ID3v1', url: 'https://id3.org/ID3v1' },
        { label: 'id3.org — History', url: 'https://id3.org/History' },
        { label: 'id3.org — Introduction', url: 'https://id3.org/Introduction' }
      ],
      kracLinks: [
        { label: 'KracRadio (FR)', url: 'https://kracradio.com/' },
        { label: 'KracRadio (EN)', url: 'https://kracradio.com/en' }
      ]
    }
  },

  es: {
    title: 'MP3 Tag Editor Pro',
    subtitle: 'Editor de etiquetas MP3 en línea',
    loadFiles: 'Cargar archivos',
    downloadAll: 'Descargar todos los MP3',
    files: 'Archivos',
    search: 'Buscar...',
    noFiles: 'No se cargaron archivos',
    clickToStart: 'Haz clic en "Cargar archivos" para empezar',
    tags: 'Etiquetas',
    cover: 'Carátula',
    export: 'Exportar',
    save: 'Guardar',
    saving: 'Guardando...',
    downloadModified: 'Descargar MP3 modificado',
    addCover: 'Añadir carátula',
    loadImage: 'Cargar imagen',
    remove: 'Eliminar',
    processing: 'Procesando...',
    ready: 'Listo',
    filesLoaded: 'archivo(s) cargado(s)',
    unsavedChanges: 'Tienes cambios sin guardar. ¿Quieres guardarlos antes de continuar?',
    applyToAll: 'Aplicar esta carátula a todos los archivos',
    selectFile: 'Selecciona un archivo',
    clickToAddCover: 'Haz clic para añadir una carátula',
    unknownArtist: 'Artista desconocido',
    selectedFile: 'Archivo seleccionado:',
    howToUse: 'Cómo usar',
    collectionStats: 'Estadísticas de la colección',
    withArtist: 'Con artista',
    withAlbum: 'Con álbum',
    albumLevel: 'Nivel álbum',
    trackLevel: 'Nivel pista',
    trackNeedsSelection: 'Selecciona una pista para editar sus campos específicos.',
    albumTitleLabel: 'Título del álbum',
    albumArtistLabel: 'Artista del álbum',
    trackTitleLabel: 'Título de la pista',
    trackArtistLabel: 'Artista de la pista',
    albumCommentLabel: 'Comentario global',
    trackCommentLabel: 'Comentario de la pista',
    albumCoverTitle: 'Carátula del álbum',
    trackCoverTitle: 'Carátula específica de la pista',
    coverAlbumHeader: 'Carátula actual',
    coverTrackHeader: 'Carátula actual',
    sharedCoverHint: 'Haz clic para definir la carátula compartida',
    trackCoverFallback: 'Haz clic para añadir una carátula',
    albumModeLabel: 'Modo álbum',
    albumModeEnable: 'Activar',
    albumModeDisable: 'Desactivar',
    albumModeHintOn: 'Los campos del álbum se aplican a todas las pistas.',
    albumModeHintOff: 'Cada pista se gestiona individualmente.',
    albumModeSelectPrompt: 'Se cargaron varios archivos ({count}). Ingresa el número del archivo que contiene la información común (deja vacío para empezar desde cero):',
    albumModeResetConfirm: '¿Reiniciar la información del álbum desde cero?',
    advancedModeLabel: 'Modo avanzado',
    advancedModeEnable: 'Mostrar todo',
    advancedModeDisable: 'Ocultar extras',
    advancedModeHintOn: 'Todos los campos están visibles.',
    advancedModeHintOff: 'Solo se muestran los campos esenciales.',
    coverApplyAlbum: 'Aplicar al álbum',
    coverApplyAll: 'Aplicar a toda la lista',
    confirmTitle: 'Confirmación',
    confirmYes: 'Sí',
    confirmNo: 'No',
    confirmCoverAlbum: '¿Aplicar esta carátula a todas las pistas del álbum?',
    confirmCoverAll: '¿Aplicar esta carátula a todos los archivos de la lista?',
    confirmApplyAlbum: 'Aplicar al álbum',
    confirmApplyAll: 'Aplicar a todos',
    confirmAlbumEnable: '¿Activar el modo álbum? Los campos compartidos se aplicarán a todas las pistas.',
    confirmAlbumDisable: '¿Desactivar el modo álbum? Las pistas volverán a ser independientes.',
    sources: 'Fuentes',
    sourceSelect: 'Fuente de metadatos',
    sourceDiscogsTokenLabel: 'Token personal de Discogs',
    sourceDiscogsTokenPlaceholder: 'token123456...',
    sourceDiscogsTokenHelp: 'Usa un token personal de Discogs (Configuración > Desarrolladores) o una pareja key/secret.',
    sourceDiscogsKeyLabel: 'Clave API de Discogs',
    sourceDiscogsKeyPlaceholder: 'miClave123',
    sourceDiscogsSecretLabel: 'Secreto API de Discogs',
    sourceDiscogsSecretPlaceholder: 'miSecreto456',
    sourceDiscogsKeyHelp: 'También puedes proporcionar una clave + un secreto (Configuración > Aplicaciones) en lugar del token.',
    sourceQueryLabel: 'Búsqueda global',
    sourceQueryPlaceholder: 'Nombre del álbum o pista',
    sourceArtistLabel: 'Filtro de artista',
    sourceArtistPlaceholder: 'Nombre del artista',
    sourceAlbumLabel: 'Filtro de lanzamiento',
    sourceAlbumPlaceholder: 'Álbum o lanzamiento',
    sourceSearchButton: 'Buscar metadatos',
    sourceSearching: 'Buscando...',
    sourceClear: 'Limpiar resultados',
    sourceResultsCount: '{count} resultado(s)',
    sourceApplied: 'Metadatos aplicados al archivo actual',
    sourceApplying: 'Aplicando metadatos...',
    sourceNoResults: 'No se encontraron lanzamientos coincidentes.',
    sourceApply: 'Aplicar al archivo',
    sourceOpenLink: 'Abrir página de origen',
    sourceUnknownTitle: 'Lanzamiento sin título',
    sourceScore: 'Puntaje: {score}',
    sourceCountryLabel: 'País',
    sourceLabelLabel: 'Sello',
    sourceCustomTitle: 'Fuentes personalizadas',
    sourceCustomDescription: 'Agrega endpoints JSON sencillos como fuentes de metadatos. Usa {query}, {artist}, {album} o {track} en la URL.',
    sourceCustomName: 'Nombre de la fuente',
    sourceCustomNamePlaceholder: 'Mi catálogo de vinilos',
    sourceCustomUrl: 'Plantilla de URL',
    sourceCustomUrlPlaceholder: 'https://ejemplo.com/buscar?term={query}',
    sourceCustomResultPath: 'Ruta del resultado',
    sourceCustomResultPathPlaceholder: 'data.items',
    sourceCustomTagsJson: 'Mapeo adicional de tags (JSON)',
    sourceCustomTagsJsonPlaceholder: '{"composer":"meta.composer"}',
    sourceCustomFieldMapLabel: 'Ruta para {field}',
    sourceCustomFieldMapPlaceholder: 'ej. metadata.titulo',
    sourceCustomAdd: 'Agregar fuente personalizada',
    sourceCustomHint: 'La respuesta debe ser JSON (objeto o arreglo).',
    sourceCustomListTitle: 'Fuentes personalizadas guardadas',
    sourceCustomEmpty: 'Aún no hay fuentes personalizadas.',
    sourceErrors: {
      emptyQuery: 'Ingresa al menos un término de búsqueda (consulta, artista o álbum).',
      noFile: 'Selecciona un archivo antes de aplicar metadatos.',
      missingFields: 'El nombre y la plantilla de URL son obligatorios.',
      invalidTagsJson: 'JSON inválido para los tags adicionales.',
      auth: 'Se requiere autenticación o las credenciales son inválidas.',
      rateLimit: 'Se alcanzó el límite de solicitudes. Intenta de nuevo más tarde.',
      generic: 'No se pudieron obtener metadatos de la fuente seleccionada. Inténtalo de nuevo más tarde.'
    },
    fieldLabels: {
      title: 'Título',
      artist: 'Artista',
      album: 'Álbum',
      albumArtist: 'Artista del álbum',
      year: 'Año',
      track: 'Pista',
      totalTracks: 'Número de pistas',
      disc: 'Disco',
      totalDiscs: 'Número de discos',
      genre: 'Género',
      comment: 'Comentario',
      composer: 'Compositor',
      bpm: 'BPM',
      key: 'Tonalidad',
      language: 'Idioma',
      copyright: 'Copyright',
      encoder: 'Codificador',
      lyrics: 'Letras'
    },
    header: {
      home: 'MP3 TAG EDITOR',
      about: 'Acerca de',
      history: 'Historial',
      contact: 'Contacto',
      kracRadio: 'KracRadio',
      donation: 'Donar',
      store: 'Tienda'
    },
    footer: {
      description: "Editor de etiquetas MP3 en línea, gratuito y fácil de usar. Modifica tus metadatos musicales directamente en tu navegador.",
      usefulLinks: "Enlaces útiles",
      guide: "Guía de uso",
      formats: "Formatos soportados",
      faq: "FAQ",
      reportBug: "Reportar un error",
      contact: "Contacto",
      codeOnGithub: "Código fuente en GitHub",
      madeWithLove: "Hecho con pasión",
      localProcessing: "Procesamiento 100% local",
      noUpload: "Ningún archivo enviado al servidor",
      openSource: "Código abierto y gratuito",
      privacy: "Privacidad",
      terms: "Términos de uso",
      rightsReserved: "Todos los derechos reservados.",
      version: "Versión",
      information: "Información"
    },
    contactPage: {
      title: 'Contacto',
      subtitle: 'Envíanos un mensaje; solemos responder rápido.',
      nameLabel: 'Nombre',
      emailLabel: 'Correo',
      messageLabel: 'Mensaje',
      namePlaceholder: 'Tu nombre',
      emailPlaceholder: 'tú@ejemplo.com',
      messagePlaceholder: 'Tu mensaje...',
      send: 'Enviar',
      sending: 'Enviando...',
      successTitle: '¡Gracias!',
      successBody: 'Tu mensaje ha sido enviado. Te responderemos pronto.',
      errorTitle: 'Uy…',
      errorBody: 'No se pudo enviar el mensaje. Inténtalo más tarde.'
    },
    historyPage: {
      title: 'Historial',
      subtitle: 'Notas de lanzamiento y cambios recientes.',
      sourceReleases: 'Fuente: GitHub Releases',
      sourceCommits: 'Fuente: Commits (rama)',
      publishedOn: 'Publicado el',
      by: 'por',
      viewOnGitHub: 'Ver en GitHub',
      noItems: 'No hay elementos para mostrar.'
    },
    aboutPage: {
      title: 'Acerca de KEMP3',
      intro: 'KEMP3 es un editor de etiquetas MP3 rápido y privado en el navegador. Sin instalaciones ni subidas: editas y descargas.',
      versionLabel: 'Versión',
      releasedOn: 'Publicado el',
      featuresTitle: 'Qué incluye 1.0',
      privacyTitle: 'Privacidad por diseño',
      privacyBody: 'Todo el procesamiento de audio ocurre localmente en tu navegador. No se envían archivos de audio ni metadatos a ningún servidor.',
      kracTitle: 'Creado para KracRadio',
      kracBody: 'KEMP3 es desarrollado por H1Site.com para KracRadio, una webradio independiente de Montreal que destaca música indie y underground a través de varios canales.',
      sourcesTitle: 'Fuentes',
      readMore: 'Mostrar detalles',
      readLess: 'Ocultar detalles',
      features: [
        "Edición completa de etiquetas MP3 (título, artista, álbum, año, pista, género, letras, …)",
        "Añadir/eliminar carátula + aplicar a todos los archivos",
        "Descarga por lotes con etiquetas integradas",
        "Exportaciones: CSV / HTML / JSON",
        "Búsqueda + estadísticas de la colección",
        "3 idiomas (FR / EN / ES)",
        "Sin subidas: procesamiento 100% local",
        "Tema claro/oscuro + header/footer responsive"
      ],
      nameTitle: '¿Por qué “KEMP3”?',
      nameBody1: 'El nombre honra a Eric Kemp (“NamkraD”), quien introdujo el primer formato de etiquetas ID3 (ID3v1) en 1996: una etiqueta de 128 bytes añadida al final de los MP3.',
      nameBody2: 'Kemp fue músico y programador — justo el espíritu que celebramos aquí: práctico, musical y orientado al maker.',
      nameSources: [
        { label: 'id3.org — ID3v1', url: 'https://id3.org/ID3v1' },
        { label: 'id3.org — History', url: 'https://id3.org/History' },
        { label: 'id3.org — Introduction', url: 'https://id3.org/Introduction' }
      ],
      kracLinks: [
        { label: 'KracRadio (FR)', url: 'https://kracradio.com/' },
        { label: 'KracRadio (EN)', url: 'https://kracradio.com/en' }
      ]
    }
  }
};

// Helper pratique : renvoie le dictionnaire actif
export const getT = (lang = 'fr') => translations[lang] || translations.fr;

// Pour lister les langues disponibles
export const availableLanguages = Object.keys(translations);
